import { createSelector } from 'reselect';
const getItemMapOpened = (state) => state.journeyMap.opened;
const getItemType = (state) => state.journeyMap.idType;
const getItem = createSelector(
  (state) => state.journeyMap.data,
  (item) => item
);
const getDriverPositions = createSelector(
  (state) => state.journeyMap.positions,
  (driverPositions) => driverPositions
);
const getFetching = (state, fetching) => state.journeyMap.fetching[fetching];

const getDriverInfoIsLoading = (state) => state.journeyMap.driverInfo.loading;
const getDriverInfoIsAssigning = (state) => state.journeyMap.driverInfo.assigning;

const getDriverInfoIsOpened = (state) => state.journeyMap.driverInfo.opened;
const getDriverInfoData = (state) => state.journeyMap.driverInfo.driverData;
const getDriverInfoDriverId = (state) => {
  const driver = state.journeyMap.driverInfo.driverData;
  return driver ? driver.id : null;
};
const getDriverInfoPositionData = (state) => state.journeyMap.driverInfo.positionData;
const getDriverInfoAssignDone = (state) => state.journeyMap.driverInfo.assignDone;
const getDriverInfoAssignError = (state) => state.journeyMap.driverInfo.assignError;

export {
  getItemMapOpened,
  getItemType,
  getItem,
  getDriverPositions,
  getFetching,
  getDriverInfoIsLoading,
  getDriverInfoIsOpened,
  getDriverInfoData,
  getDriverInfoPositionData,
  getDriverInfoDriverId,
  getDriverInfoIsAssigning,
  getDriverInfoAssignDone,
  getDriverInfoAssignError,
};
